<ng-container [formGroup]="formGroup">
    <!-- Treasury org: readonly display -->
    <ng-container *ngIf="isTreasuryLocked">
        <input type="text"
               class="form-control"
               [value]="treasuryAccountName"
               disabled
               readonly />
        <small *ngIf="treasuryProvisioningSlow" class="treasury-provisioning-hint">
            {{ 'Setting up your PayHOA Balance is taking longer than usual. Please refresh this page in a few minutes.' }}
        </small>
    </ng-container>

    <!-- Non-treasury / loading: selector with built-in spinner -->
    <mat-form-field *ngIf="!isTreasuryLocked" appearance="outline" class="w-100 bg-white">
        <mat-select [formControlName]="controlName" placeholder="Select Bank Account" [compareWith]="comparator">
            <mat-option *ngIf="allowCreate" [value]="null" (click)="addBankAccount()">Add New Bank Account</mat-option>
            <ng-container *ngIf="!isLoadingAccounts">
                <ng-container *ngFor="let acct of bankAccounts; trackBy: trackByDepositAccountId">
                    <mat-option [value]="acct" [hidden]="acct.deletedAt && acct.id !== formGroup.get(controlName).value?.id">
                        {{acct.friendlyName}}
                        <ng-container *ngIf="acct.deletedAt">(deleted)</ng-container>
                    </mat-option>
                </ng-container>
            </ng-container>
        </mat-select>
        <mat-spinner *ngIf="isLoadingAccounts" [diameter]="15"></mat-spinner>
    </mat-form-field>
</ng-container>
